import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./theme/tokens.css";
import "./index.css";
import App from "./App.js";
import { ClerkProvider } from "@clerk/react";

console.log("REACT_APP_CLERK_PUBLISHABLE_KEY:", process.env.REACT_APP_CLERK_PUBLISHABLE_KEY);
console.log("REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
console.log("REACT_APP_WS_CHAT_URL:", process.env.REACT_APP_WS_CHAT_URL);

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <ClerkProvider publishableKey={process.env.REACT_APP_CLERK_PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </StrictMode>,
);
